import { useEffect, useMemo } from 'react';

import { CONTRACT_TYPE_QUERY_PARAM } from '@telialt/core-eshop/src/constants';
import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import { ContractType } from '@telialt/models/src/EshopModel';
import { selectProductInCart } from '@telialt/utils/src/eshopSelectors';
import { isSSR, removeQueryParam } from '@telialt/utils/src/helpers';

import { useMutateContractType } from '../components/ProductDetailsPage/ContractTypeSelector/useMutateContractType';

const contractTypeQueryValuesMap = {
    'with-plan': ContractType.WithPlan,
    'without-plan': ContractType.WithoutPlan,
    renting: ContractType.Renting,
};

const readContractTypeFromQuery = (): ContractType => {
    if (isSSR()) {
        return undefined;
    }
    const contractTypeQueryValue = new URLSearchParams(window.location.search).get(CONTRACT_TYPE_QUERY_PARAM);

    return contractTypeQueryValuesMap[contractTypeQueryValue];
};

export const useSelectContractTypeFromQuery = () => {
    const { cart } = useCartQuery();

    const contractTypeInQuery = useMemo(() => readContractTypeFromQuery(), []);

    const { mutateContractType, isLoadingMutateContractType: isSelectContractTypeLoading } = useMutateContractType();

    const hasProductInCart = !!selectProductInCart(cart);

    useEffect(() => {
        if (contractTypeInQuery && hasProductInCart) {
            removeQueryParam(CONTRACT_TYPE_QUERY_PARAM);
            mutateContractType(contractTypeInQuery);
        }
    }, [contractTypeInQuery, hasProductInCart, mutateContractType]);

    return { isSelectContractTypeLoading };
};
